import React from "react";

const Footer = () => {
  return (
    <div className="flex flex-col lg:flex-row bottom-0 w-full h-fit p-4 bg-[#F2F2F2] justify-center sm:justify-between items-center text-xs text-center border-t border-slate-300 gap-4 lg:gap-0 z-50">
      <div>
        Copyright @{new Date().getFullYear()} JK Millenium Computer Center
      </div>
      <div>
        All rights reserved. All trademarks / registered trademarks belong to
        their respective owners.
      </div>
    </div>
  );
};

export default Footer;
